<template>
  <div class="usage-agreement">
    <div class="agreement-content">
      <h2 style="color: white; text-align: center;">
        営業トークサポートAI<br>遵守事項
      </h2>
      
      <div class="agreement-text">
        <ul style="list-style-type: disc; padding-left: 20px; color: white; text-align: left;">
          <li>営業トークサポートAIによって生成される営業トーク例は、生成AIを使って作成しています。セブン－イレブン・ジャパンの公式見解ではない事をご理解の上でご活用下さい。</li>
          <li>営業トークサポートAIによって生成された内容を、そのまま外部に公開することはお控えください。</li>
          <li>営業トークサポートAIを、不正に利益を得る目的や、他人に損害を与えるなどの目的での使用はお控えください。</li>
        </ul>
      </div>

      <div class="checkbox-container">
        <v-checkbox
          v-model="agreed"
          label="上記内容を理解しました。"
          color="green"
          style="color: white;"
        ></v-checkbox>
      </div>

      <div class="button-container">
        <v-btn
          :disabled="!agreed"
          @click="navigateToSalesTalk"
          style="
            background-color: lightgreen;
            color: white;
            border-radius: 15px;
            padding: 4px 8px;
            font-size: 12px;
          "
        >
          利用開始
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();
const agreed = ref(false);

const navigateToSalesTalk = () => {
  const articleId = route.params.article_id;
  router.push({
    name: 'SalesTalk',
    params: { article_id: articleId }
  });
};
</script>

<style scoped>
.usage-agreement {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}

.agreement-content {
  background-color: black;
  padding: 20px;
  border-radius: 8px;
  width: 50vw;
  max-width: 600px;
}

.agreement-text {
  margin: 20px 0;
  line-height: 1.6;
}

.checkbox-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.button-container {
  text-align: center;
  margin-top: 20px;
}

@media (max-width: 768px) {
  .agreement-content {
    width: 90vw;
    margin: 20px;
  }
}
</style>
